/**
 * Article Social Share Functionality
 * Handles social media sharing for blog articles
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSocialShare);
  } else {
    initSocialShare();
  }

  function initSocialShare() {
    // Get current page URL and title
    const pageUrl = encodeURIComponent(window.location.href);
    const pageTitle = encodeURIComponent(document.title);
    
    // Setup all social share buttons
    setupTwitterShare(pageUrl, pageTitle);
    setupFacebookShare(pageUrl);
    setupLinkedInShare(pageUrl, pageTitle);
    setupInstagramShare();
    setupEmailShare(pageUrl, pageTitle);
    setupCopyLink();
  }

  function setupTwitterShare(url, title) {
    const twitterButtons = document.querySelectorAll('.share-twitter');
    twitterButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const twitterUrl = `https://twitter.com/intent/tweet?url=${url}&text=${title}`;
        window.open(twitterUrl, 'twitter-share', 'width=550,height=420');
      });
    });
  }

  function setupFacebookShare(url) {
    const facebookButtons = document.querySelectorAll('.share-facebook');
    facebookButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
        window.open(facebookUrl, 'facebook-share', 'width=550,height=420');
      });
    });
  }

  function setupLinkedInShare(url, title) {
    const linkedinButtons = document.querySelectorAll('.share-linkedin');
    linkedinButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
        window.open(linkedinUrl, 'linkedin-share', 'width=550,height=420');
      });
    });
  }

  function setupInstagramShare() {
    const instagramButtons = document.querySelectorAll('.share-instagram');
    instagramButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        // Instagram doesn't have a direct web share URL
        // Show a message to the user
        showNotification('Instagram sharing is only available on mobile devices. Please use the Instagram app to share this article.', 'info');
      });
    });
  }

  function setupEmailShare(url, title) {
    const emailButtons = document.querySelectorAll('.share-email');
    emailButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const decodedUrl = decodeURIComponent(url);
        const decodedTitle = decodeURIComponent(title);
        const subject = encodeURIComponent(`Check out: ${decodedTitle}`);
        const body = encodeURIComponent(`I thought you might find this interesting:\n\n${decodedTitle}\n${decodedUrl}`);
        window.location.href = `mailto:?subject=${subject}&body=${body}`;
      });
    });
  }

  function setupCopyLink() {
    const copyButtons = document.querySelectorAll('.copy-link-btn');
    copyButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const url = window.location.href;
        
        // Try to use the Clipboard API
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url)
            .then(() => {
              showNotification('Link copied to clipboard!', 'success');
            })
            .catch(() => {
              // Fallback if clipboard API fails
              fallbackCopyToClipboard(url);
            });
        } else {
          // Fallback for older browsers
          fallbackCopyToClipboard(url);
        }
      });
    });
  }

  function fallbackCopyToClipboard(text) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        showNotification('Link copied to clipboard!', 'success');
      } else {
        showNotification('Failed to copy link. Please copy manually.', 'error');
      }
    } catch (err) {
      showNotification('Failed to copy link. Please copy manually.', 'error');
    }
    
    document.body.removeChild(textArea);
  }

  function showNotification(message, type) {
    // Check if notification element exists
    let notification = document.getElementById('copy-notification');
    
    if (!notification) {
      // Create notification element if it doesn't exist
      notification = document.createElement('div');
      notification.id = 'copy-notification';
      notification.className = 'copy-notification';
      document.body.appendChild(notification);
    }
    
    // Set message and type
    notification.textContent = message;
    notification.className = `copy-notification ${type}`;
    
    // Show notification
    notification.classList.add('show');
    
    // Hide after 3 seconds
    setTimeout(() => {
      notification.classList.remove('show');
    }, 3000);
  }

})();
